import styled from 'styled-components';

export const Container = styled.div`
	position: relative;
	display: flex;
	align-items: center;
	margin-bottom: 20px;
	max-width: 400px;
`;

export const SearchIcon = styled.div`
	position: absolute;
	left: 12px;
	color: ${({ theme }) => theme.gray[600]};
	pointer-events: none;
	display: flex;
	align-items: center;
`;

export const Input = styled.input`
	width: 100%;
	padding: 8px 12px 8px 40px;
	border: 1px solid ${({ theme }) => theme.gray[200]};
	border-radius: 8px;
	font-size: 14px;
	background-color: ${({ theme }) => theme.gray[0]};
	color: ${({ theme }) => theme.gray[1000]};
	transition: border-color 0.2s ease;

	&:focus {
		outline: none;
		border-color: ${({ theme }) => theme.blue[500]};
	}

	&::placeholder {
		color: ${({ theme }) => theme.gray[400]};
	}
`;

export const ClearButton = styled.button`
	position: absolute;
	right: 8px;
	padding: 4px;
	border: none;
	background: none;
	color: ${({ theme }) => theme.gray[600]};
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 4px;
	transition: background-color 0.2s ease, color 0.2s ease;

	&:hover {
		background-color: ${({ theme }) => theme.gray[100]};
		color: ${({ theme }) => theme.gray[1000]};
	}

	&:focus-visible {
		outline: 2px solid ${({ theme }) => theme.blue[500]};
		outline-offset: 2px;
	}
`;
